import _ from 'lodash';
import React from 'react';
import MainMenu from 'src/components/containers/main-menu';
import { Card, Layout, Page, Badge, Tooltip } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import VerticalTab from 'src/components/containers/vertical-tab';
import { connect } from 'react-redux';

import AISynonym from 'src/components/containers/synonym/ai-synonym';
import SemanticSearch from 'src/components/containers/advanced-search/semantic-search';
import ProductPerformanceRanking from 'src/components/containers/product-performance-ranking';
import SearchPersonalization from 'src/components/containers/search-personalization';

import IconWand from 'src/assets/images/standard-search/wand.svg';
import BannersNewVersion from 'src/components/containers/common/switchNewVersion/search';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';
import PremiumLockCard from 'src/components/views/advanced-search/premium-lock-card';

import { ADDONS_INFO, AI_POWERED_SEARCH_NAME } from 'src/constants/subscription';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';

import { routes } from 'src/routes';
import history from 'src/routes/history';

import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';
import { checkUseSearchPersonalization } from 'src/helpers/subscription-v3-helper';

import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';
import * as checklistActions from 'actions/dashboard/checklist-actions';
import * as SemanticActions from 'actions/semantic-action';
import testSearchIcon from 'src/assets/images/common/test-search-icon.png';

const AdvanceSearch = props => {
  const {
    i18n,
    invoice,
    isNewSearch,
    enableAISearch,
    addonStatus,
    statusStore,
    notAllowAddon,
    getAddonStatus,
    isUsePersonalization,
    getDetailInvoice,
    triggerCheckSyncSemantic,
    getSemanticSettings
  } = props;
  const [tab, setTab] = React.useState(routes.aiSynonym.view());
  const [modalAddon, setModalAddon] = React.useState(false);

  const addonRemainingCycles = _.get(addonStatus, 'trialInfo.remainingDays', 14);

  const isSubscribeNow =
    !['trial', 'expiredSoon'].includes(statusStore) && addonRemainingCycles <= 0;

  React.useEffect(() => {
    // Get current addon status
    getAddonStatus(AI_POWERED_SEARCH_NAME);
    // Get detail invoice
    if (_.isEmpty(invoice) || !invoice) {
      getDetailInvoice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let tabs = [
    {
      id: routes.aiSynonym.view(),
      content: i18n.translate('AdminHTML.AdvanceSearch.Tabs.aiSynonym')
    },
    {
      id: routes.semanticSearch.view(),
      content: i18n.translate('AdminHTML.AdvanceSearch.Tabs.semanticSearch')
    },
    {
      id: routes.productPerformanceRanking.view(),
      content: i18n.translate('AdminHTML.AdvanceSearch.Tabs.productPerformanceRanking')
    }
  ];

  const childrenMap = {
    [routes.aiSynonym.view()]: <AISynonym />,
    [routes.semanticSearch.view()]: <SemanticSearch />,
    [routes.productPerformanceRanking.view()]: <ProductPerformanceRanking />
  };

  if (isUsePersonalization) {
    tabs.push({
      id: routes.searchPersonalization.view(),
      content: i18n.translate('AdminHTML.AdvanceSearch.Tabs.searchPersonalization'),
      isBeta: true
    });

    childrenMap[routes.searchPersonalization.view()] = <SearchPersonalization />;
  }

  React.useEffect(() => {
    const pathname = props.location.pathname;
    if (pathname === routes.advancedSearch.view()) {
      history.push(routes.aiSynonym.view());
      return;
    }
    setTab(pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname]);

  const onClickLockCard = () => {
    if (notAllowAddon) return;
    setModalAddon(!modalAddon);
    mixpanelV3Helper.trackOpenSubscriptionReview(
      AI_POWERED_SEARCH_NAME,
      window.location.pathname,
      i18n.translate(
        `AdminHTML.Common.Action.${isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'}`
      )
    );
  };

  /** Subscribe addon - reload page*/
  const handleCloseStatus = () => {
    getAddonStatus(AI_POWERED_SEARCH_NAME);
    getSemanticSettings();
    triggerCheckSyncSemantic();
  };

  return (
    <div className="BC-Page BC-Page__StandardSearch BC-Page__AdvancedSearch">
      <MainMenu menuId="menu-search-ai-power-search" />
      <Page
        title={
          <div className="page-title-wrapper">
            <h1 className="Polaris-Header-Title Polaris-Header-Title__TitleWithSubtitle">
              {i18n.translate('AdminHTML.AdvanceSearch.title')}
            </h1>
            <Badge>
              <img src={IconWand} alt="wand" />
              <span>{i18n.translate('AdminHTML.AdvanceSearch.iconText')}</span>
            </Badge>
          </div>
        }
        subtitle={
          <div className="ref-to-test-search">
            <p>{i18n.translate('AdminHTML.AdvanceSearch.description')}</p>
            {isNewSearch && (
              <Tooltip
                content={i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.tooltip')}
                preferredPosition="above">
                <p onClick={() => history.push(routes.testYourSearch.view())}>
                  <img width={16} height={16} src={testSearchIcon} alt="pfs-test-search-icon" />
                  {i18n.translate('AdminHTML.TestYourSearch.TestYourSearch.title')}
                </p>
              </Tooltip>
            )}
          </div>
        }
        titleMetadata={<div className="standard-search-title"></div>}>
        <div className="layout-wrapper">
          {!enableAISearch ? (
            <Layout>
              <Layout.Section>
                <PremiumLockCard
                  disableLockUnLock={notAllowAddon}
                  isSubscribeNow={isSubscribeNow}
                  action={onClickLockCard}
                />
              </Layout.Section>
            </Layout>
          ) : (
            <Layout>
              <Layout.Section>
                <BannersNewVersion />
              </Layout.Section>
              <Layout.Section>
                <Card sectioned>
                  <div className="BC-Page AdvanceSearch__Content BC-Page__Fields">
                    <VerticalTab
                      tabs={tabs}
                      scope="advanced"
                      children={childrenMap[tab]}
                      selectedId={tab}
                      onSelected={tab => {
                        history.push(tab);
                      }}
                    />
                  </div>
                </Card>
              </Layout.Section>
            </Layout>
          )}
        </div>
      </Page>
      {/* Process addon unlock */}
      <ProcessAddon
        openModalReview={modalAddon}
        addon={ADDONS_INFO.find(e => e.addonName === AI_POWERED_SEARCH_NAME)}
        hadSubscribed={isSubscribeNow}
        handleAfterSubscribeAddon={handleCloseStatus}
        handleReviewModal={() => setModalAddon(!modalAddon)}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Get current status addon sync
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n)),
  trackEvent: (eventSource, eventName, label) =>
    dispatch(checklistActions.trackEvent(eventSource, eventName, label)),
  getSemanticSettings: () => dispatch(SemanticActions.getSemanticSettings()),
  triggerCheckSyncSemantic: () => dispatch(SemanticActions.triggerCheckSyncSemantic())
});

const mapStateToProps = state => {
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const isUsePersonalization = checkUseSearchPersonalization(tenantApp);

  return {
    isNewSearch,
    isUsePersonalization,
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    addonStatus: _.get(state.subscriptionV3, `addonStatus.${AI_POWERED_SEARCH_NAME}`, {}),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    enableAISearch: _.get(
      state.oauth.tenantApp,
      'settings.instantSearch.settings.AI-synonyms',
      false
    )
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(AdvanceSearch));
